import React from 'react';
import styled, { css } from 'styled-components';

import SubmitButton from 'components/buttons/SubmitButton';
import SectionTitle from 'components/previewPages/SectionTitle';

type Props = {
  isMobile?: boolean;
};

const CheckoutSection = (
  { isMobile = false }: Props,
  ref: React.Ref<HTMLDivElement>
) => {
  return (
    <Container ref={ref} $isMobile={isMobile}>
      <SectionTitle isMobile={isMobile}>
        Start your free 1 month trial today
      </SectionTitle>
      <Subtitle $isMobile={isMobile}>No commitment. Cancel anytime.</Subtitle>
      <SubmitButton
        isDisabled={false}
        buttonSize={isMobile ? 'sm' : 'xl'}
        fontSize={isMobile ? 'sm' : 'md'}
        borderSize={isMobile ? 'sm' : 'xl'}
        text="Try for free"
      />
    </Container>
  );
};

const Subtitle = styled.p<{ $isMobile: boolean }>`
  font-size: 20px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.topicBlue};
  text-align: center;
  margin-bottom: 34px;
  line-height: 35px;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      font-size: 14px;
      line-height: 20px;
    `}
`;

const Container = styled.section<{ $isMobile: boolean }>`
  max-width: 1400px;
  padding: 78px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      padding: 34px 0;
    `}
`;

export default React.forwardRef(CheckoutSection);
